<div class="col-12 mt-4 ml-0 pl-0 mb-3">
  <a class="cursor-pointer color-negro btn-volver" (click)="validarVolver();" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER">
    <i class="bi bi-chevron-left mr-2"></i>
    Volver
  </a>
</div>
<h1 class="d-xl-none">Registro de calificaciones</h1>

<!-- STICKY PART -->
<div class="sticky-part">
  <!-- COLLAPSE DESCRIPCIÓN CALIFICACIÓN -->
  <div class="mt-4 d-xl-none">
    <div class="row">
      <div class="col-9 col-sm-10 col-md-10 col-lg-11">
        <p class="mb-0 mx-1 pt-3 tamanio-texto-calificaciones_responsive" style="font-size: 1.3rem !important;">
          CALIFICACIÓN {{ dataSeleccion?.header?.tipoNota === 'CP' ? 'PARCIAL' : 'EXAMEN' }}: <strong>{{ dataSeleccion?.header?.valor }}</strong>
        </p>
      </div>
      <div class="col">
        <button class="btn" (click)="toggleDetail()"><i [ngClass]="!showDetail ?  'bi-plus-circle' : 'bi-dash-circle'" class="bi tamanio_iconos-boton ml-3"></i></button>
      </div>
    </div>
  </div>

  <div class="row d-xl-none" *ngIf="showDetail">
    <span class="mx-4 mt-2">
      {{ dataSeleccion?.header?.descripcion ?? 'Sin descripción' }}
    </span>
  </div>
  <!-- FIN COLLAPSE DESCRIPCIÓN CALIFICACIÓN -->

  <!-- DATOS SECCIÓN -->
  <div class="py-2 my-4 borde_inferior_datos_secciones borde_superior_datos_secciones d-xl-none">
    <p class="mb-1 mt-3 text-uppercase">{{ asignatura?.asignatura }}</p>
    <p class="mb-1 text-uppercase">{{ asignatura?.periodo }}</p>
    <p class="mb-1 text-uppercase" *ngFor="let docente of docentes">{{ docente.docente }}</p>
    <p class="mb-3 text-uppercase">{{ asignatura?.sede }}</p>
  </div>
  <!-- FIN SECCIÓN -->
</div>

<!-- BUSCAR -->

<label class="titulo_criterios mx-3 d-xl-none" for="exampleFormControlSelect2">Buscar</label>
<div class="input-group z-index--1 mb-5 d-xl-none">
  <input type="text" class="form-control select_criterios mx-3" [(ngModel)]="nombreRutAlumnoFiltro" placeholder="Nombre o RUT">
</div>
<!-- FIN BUSCAR -->

<!-- INGRESO CALIFICACION -->
<ng-container *ngFor="let body of tablaCalificaciones?.body | filtroAlumnos: nombreRutAlumnoFiltro; let indexBody = index">
  <ng-container *ngFor="let row of body.row; let indexRow = index; let last = last; let odd = odd;">
    <div 
      *ngIf="indexRow === dataSeleccion?.indexHeader" 
      class="borde_inferior_datos_secciones borde_superior_datos_secciones d-xl-none"
    >
      <p class="text-uppercase mt-4 mb-2 mx-4 datos_alumnos-suspensivo">
        <strong>{{ body.row[getHeaderIndexByKey('Nombre')].valor }}</strong></p>
      <span class="mx-4">{{ body.row[getHeaderIndexByKey('RUT')].valor }}</span>
      <div class="input-group z-index--1 mb-4 mt-3">
        <input 
          [disabled]="!row.editable || !registrosEditables || tablaCalificaciones?.headers?.[dataSeleccion?.indexHeader]?.editable === false || !body.editable" 
          type="text" 
          class="form-control text-center mx-4 input_ingreso_calificacion" 
          placeholder="0,0"
          [value]="row?.nuevoValor ?? row.valor"
          (input)="modificarCalificacion(indexBody, indexRow, row, $event)"
          (keypress)="allowNumericDigitsOnlyOnKeyUp($event, indexBody, indexRow, row)"
          (keyup)="keyUpCalificacion($event, indexBody, indexRow, row)"
          (focusout)="focusOut($event, indexBody, indexRow, row)"
          onpaste="return false;"
        >
      </div>
    </div>
  </ng-container>
</ng-container>


<!-- FIN INGRESO CALIFICACION -->

<div class="mb-5 mt-5 centrar_contenido d-xl-none z-index--1">
  <div *ngIf="alertaExito !== ''" class="alert alert-success alerta_calificaciones tipografía_alertas alerta_mobile z-index--1 alerta_calificaciones_mobile" role="alert">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{ alertaExito }}
  </div>

  <button 
    class="boton-primario tamanio_minimo boton_fixed_grabar_mobile ml-3" 
    data-toggle="tooltip"
    data-placement="top" 
    title="GUARDAR" 
    alt="GUARDAR"
    (click)="guardarCalificaciones()"
  >
    GUARDAR
  </button>
</div>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
	Modal info
</button>

<!-- Modal Volver con cambios pendientes -->
<button id="btn-modal-cambios-pendientes" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-cambios-pendientes">
	Modal info
</button>

<div class="modal fade" id="modal-cambios-pendientes" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>

      <div class="modal-body">
        <div class="mb-2">
          <p class="text-left ml-3">Hay cambios pendientes que no han sido guardados.</p>
          <p class="text-left ml-3">¿Deseas guardar los cambios?</p>
        </div>
      </div>

      <div class="modal-footer justify-content-center text-center">
        <button (click)="guardarCalificaciones(false, true)" data-dismiss="modal" class="btn boton-primario ml-3 my-2 text-center" data-toggle="tooltip" data-placement="top" title="guardar" alt="guardar">guardar</button>
        <button id="modal-cambios-pendientes-close" class="boton-secundario boton_secundario_modal text-center mx-3" data-toggle="tooltip" data-placement="top" title="CANCELAR" alt="CANCELAR" data-dismiss="modal">CANCELAR</button>
        <button (click)="volverAPortal()" class="btn no_guardar" data-toggle="tooltip" data-placement="top" title="NO GUARDAR" alt="NO GUARDAR">NO GUARDAR</button>
      </div>
    </div>
  </div>
</div>